import { selectRegionalDistrictById, selectSelectedRegionalDistricts } from 'shared/selectors/geo';
import { addRegionalDistrict, removeRegionalDistrict } from 'shared/slices/geo';
import { TAsyncThunkAction } from 'shared/types/redux';
import { updateSearchMeta } from '../../searchMeta';
import { getGeoValue } from '../../../../packages/JsonQuery';
import { selectJsonQuery } from 'shared/selectors/jsonQuery';
import { addRegionalDistrictToJsonQuery } from 'shared/utils/jsonQuery';
import { updateGeo } from 'shared/slices/jsonQuery';

export const selectRegionalDistrict =
  (id: number): TAsyncThunkAction =>
  async (dispatch, getState) => {
    const state = getState();
    const selectedDistricts = selectSelectedRegionalDistricts(state);
    const district = selectRegionalDistrictById(id)(state);
    const jsonQuery = selectJsonQuery(state);

    if (selectedDistricts.includes(id)) {
      dispatch(removeRegionalDistrict(district));
    } else {
      dispatch(addRegionalDistrict(district));
    }

    const geo = getGeoValue()(jsonQuery);
    const newGeo = addRegionalDistrictToJsonQuery(geo, id);

    dispatch(updateGeo(newGeo));
    dispatch(updateSearchMeta());
  };
